import { Icon, Text, Tooltip, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Utils } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { getColorAndIconOperation, messageError } from '../../constants';

interface StructuredOperationOperationScenarioSectionProps {
  data: Partial<{
    label: string | null;
    variation: number;
    return: number;
  }>[];
  headers?: string[];
}

export const StructuredOperationOperationScenarioSection: React.FC<
  StructuredOperationOperationScenarioSectionProps
> = ({ data, headers }) => {
  return (
    <FlatList
      showsVerticalScrollIndicator={false}
      data={data}
      ListHeaderComponent={
        <HStack
          alignItems={'center'}
          justifyContent={'space-between'}
          space={Spacing['inline.xxxs']}
          py={Spacing['inline.nano']}>
          {headers?.map((header, index) => (
            <Tooltip key={index.toString()} label={header || messageError}>
              <Box flex={index === 0 ? 1 : { base: 0.5, sm: 0.15 }}>
                <Text
                  color={'neutral.dark'}
                  numberOfLines={1}
                  variant="regular"
                  fontSize={Typography['fontsize.md']}>
                  {header || messageError}
                </Text>
              </Box>
            </Tooltip>
          ))}
        </HStack>
      }
      keyExtractor={(item, index) => item.label || index.toString()}
      ItemSeparatorComponent={() => <Box w={'full'} h={Spacing['inline.nano']} />}
      renderItem={({ item }) => {
        const variationValue = getColorAndIconOperation(item?.variation || 0);
        const returnValue = getColorAndIconOperation(item?.return || 0);

        return (
          <HStack
            alignItems={'center'}
            justifyContent={'space-between'}
            space={Spacing['inline.xxxs']}>
            <Text
              flex={1}
              color={'brand.primary.principal'}
              variant="regular"
              numberOfLines={1}
              fontSize={Typography['fontsize.md']}>
              {item.label || messageError}
            </Text>
            <HStack
              alignItems={'center'}
              space={Spacing['inline.quarck']}
              flex={{ base: 0.5, sm: 0.15 }}>
              <Icon
                size="xxxxs"
                name={variationValue.icon as IconographyTypes.Option}
                color={Color[variationValue.color]}
                testID="icon-arrow"
              />
              <Text
                color={'neutral.darkest'}
                variant="regular"
                fontSize={Typography['fontsize.md']}>
                {Utils.Mask.Percentage(item.variation)}
              </Text>
            </HStack>
            <HStack
              alignItems={'center'}
              space={Spacing['inline.quarck']}
              flex={{ base: 0.5, sm: 0.15 }}>
              <Icon
                size="xxxxs"
                name={returnValue.icon as IconographyTypes.Option}
                color={Color[returnValue.color]}
                testID="icon-arrow"
              />
              <Text
                color={'neutral.darkest'}
                variant="regular"
                fontSize={Typography['fontsize.md']}>
                {Utils.Mask.Percentage(item.return)}
              </Text>
            </HStack>
          </HStack>
        );
      }}
    />
  );
};
